import React, { useState, useEffect } from "react";
import StackedColumnChart from "../../CHARTS/StackedColumnChart";

const MoreDataForPTDC = ({ data, legendsData }) => {
  const [oldLegendChanged, setOldLegendChanged] = useState({});
  const [changedCode, setChangedCode] = useState(null);
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (!data || !legendsData) return;

    const currentLegendChanged = legendsData.legendChanged || {};
    let localChangedCode = null;

    Object.keys(currentLegendChanged).forEach((key) => {
      if (currentLegendChanged[key] !== oldLegendChanged[key]) {
        localChangedCode = key;
      }
    });

    setOldLegendChanged(currentLegendChanged);
    setChangedCode(localChangedCode); // optional, if you need it elsewhere

    const array = data[0]?.children;
    let trainNumbers = new Set();
    let detCodeCountsByTrain = {};

    if (localChangedCode) {
      array?.forEach((section) => {
        section?.children.forEach((detCode) => {
          if (detCode?.DET_CODE === localChangedCode) {
            detCode?.children.forEach((subCode) => {
              const currentSubCode = subCode?.SUB_CODE;

              subCode?.data.forEach((trainNo) => {
                const currentTrainNo = trainNo.TRAIN_NO;
                trainNumbers.add(currentTrainNo);

                if (!detCodeCountsByTrain[currentTrainNo]) {
                  detCodeCountsByTrain[currentTrainNo] = {};
                }
                if (!detCodeCountsByTrain[currentTrainNo][currentSubCode]) {
                  detCodeCountsByTrain[currentTrainNo][currentSubCode] = 0;
                }

                detCodeCountsByTrain[currentTrainNo][currentSubCode] +=
                  trainNo.TRAIN_LOST_COUNT;
              });
            });
          }
        });
      });
    }

    if (legendsData.barClicked && legendsData.barLegendName) {
      array?.forEach((section) => {
        section?.children.forEach((detCode) => {
          if (detCode?.DET_CODE === legendsData.barLegendName) {
            detCode?.children.forEach((subCode) => {
              const currentSubCode = subCode?.SUB_CODE;

              subCode?.data.forEach((trainNo) => {
                if (trainNo.TRAIN_NO === legendsData.barClicked) {
                  const currentTrainNo = trainNo.TRAIN_NO;
                  trainNumbers.add(currentTrainNo);

                  if (!detCodeCountsByTrain[currentTrainNo]) {
                    detCodeCountsByTrain[currentTrainNo] = {};
                  }
                  if (!detCodeCountsByTrain[currentTrainNo][currentSubCode]) {
                    detCodeCountsByTrain[currentTrainNo][currentSubCode] = 0;
                  }

                  detCodeCountsByTrain[currentTrainNo][currentSubCode] +=
                    trainNo.TRAIN_LOST_COUNT;
                }
              });
            });
          }
        });
      });
    }

    const categories = Array.from(trainNumbers);

    const uniqueDetCodes = [
      ...new Set(
        Object.values(detCodeCountsByTrain).flatMap((codes) =>
          Object.keys(codes)
        )
      ),
    ];

    const series = uniqueDetCodes.map((detCode) => ({
      name: detCode,
      data: categories.map(
        (trainNo) => detCodeCountsByTrain[trainNo]?.[detCode] || 0
      ),
    }));

    setChartData({ categories, series });
  }, [data, legendsData]);

  return (
    <div>
      {chartData && chartData.categories.length > 0 && (
        <div>
          <h6 className="bg-dark text-white p-1">
            More info for ( {changedCode && `Detention code-${changedCode}`}{" "}
            {legendsData.barLegendName &&
              `Detention code-${legendsData.barLegendName}`}
            {legendsData.barClicked && `,Train no -${legendsData.barClicked}`})
          </h6>

          <StackedColumnChart data={chartData} />
        </div>
      )}
    </div>
  );
};

export default MoreDataForPTDC;
